import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ErrorService } from '../services/error.service';

@Injectable()
export class AuthClientGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private errorSerivce: ErrorService
  ) {}

  canActivate() {
    return this.authService.isLoggedInAndInitClients().pipe(
      map(res => {
        if (!res) {
          this.authService.logout();

          return false;
        }

        if (res && !this.authService.getCurrentClient()) {
          this.authService.changeClient();

          return false;
        }

        return true;
      }),
      catchError(err => {
        this.errorSerivce.captureError(err);

        this.authService.logout();

        return of(false);
      })
    );
  }
}
